import React from 'react';
import {observer, inject, IReactComponent} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {IConnectivityStandaloneStore} from './connectivity-standalone.stores';
import {IAppRootStore} from '../../app.root.store';
import {resolveLogoUrl} from '../../utils/logo-url.utils';
import './connectivity-standalone.style.scss';

interface ConnectivityStandaloneMobileViewProps {
    connectivityStandaloneStore: IConnectivityStandaloneStore;
    rootStore: IAppRootStore;
}

@observer
export class ConnectivityStandaloneMobileViewComponent extends TechseeBaseComponent<ConnectivityStandaloneMobileViewProps> {
    renderInternal(): JSX.Element {
        const {localizationService} = this.props.connectivityStandaloneStore;
        const translate = localizationService.translate.bind(localizationService);

        return (
            <div className='ts-container ts-connectivity-standalone-mobile not-supported'>
                <header className='ts-topbar'>
                    <a href='/' className='logo'>
                        <img className='logo-img' src={resolveLogoUrl('')} alt='logo' />
                    </a>
                    <div className='ts-topbar-content'>
                        <div className='ts-breadcrumbs'>{translate('REACT.CONNECTIVITY_STANDALONE.VIEW.HEADER')}</div>
                    </div>
                </header>
                <div className='connectivity-standalone-container' style={{textAlign: 'center'}}>
                    <h4 className='ts-connectivity-title'>
                        {translate('REACT.CONNECTIVITY_STANDALONE.VIEW.MOBILE_TITLE')}
                    </h4>
                    <span className='ts-connectivity-description'>
                        {translate('REACT.CONNECTIVITY_STANDALONE.VIEW.MOBILE_DESCRIPTION')}
                    </span>
                </div>
            </div>
        );
    }
}

export const ConnectivityStandaloneMobileView = inject(
    'rootStore',
    'connectivityStandaloneStore'
)(ConnectivityStandaloneMobileViewComponent) as IReactComponent;
